import * as React from 'react';

import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import type { OmitStylesHTMLAttributes } from '../../types';

const sheetHeaderVariants = cva('rocco-sheet-header flex flex-col gap-y-2', {
    variants: {
        variant: {
            default:
                'border-b border-gray-900/30 px-6 pt-6 pb-3 md:pt-7 md:pb-4.5',
            borderless: 'px-6 pt-6 pb-3 md:pt-7 md:pb-4.5',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const SheetHeader = ({
    variant,
    ...props
}: OmitStylesHTMLAttributes<HTMLDivElement> &
    VariantProps<typeof sheetHeaderVariants>) => (
    <div className={sheetHeaderVariants({ variant })} {...props} />
);

SheetHeader.displayName = 'SheetHeader';
